import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Container, Typography } from "@mui/material";

// Register required components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Day1CompanyWise = () => {
  return (
    <Container maxWidth="lg" style={{ marginTop: "2em" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Day-1 - CompanyWise
      </Typography>
      <div style={{ position: "relative", width: "100%", height: "500px" }}>
        <Bar
          data={{
            labels: [
              "Microsoft",
              "Futures First",
              "ExxonMobil",
              "Axxela",
              "Texas Instruments",
              "Tata Motors",
              "Warner Bros Discovery",
              "Bajaj Auto",
              "GO Digit Insurance",
              "VeCV",
              "SLB",
              "Meesho",
              "PhonePe",
              "ONGC",
              "SRIB",
              "Squarepoint",
              "HPCL",
              "Google",
              "Airamatrix Private Ltd.",
              "Reliance Petro",
              "Accenture India",
              "Aspect Ratio",
              "SRIN",
              "Arista Networks",
              "Accenture Japan",
              "Flipkart_BD",
              "Flipkart_SDE",
              "Browserstack",
              "Axtria",
              "Intel",
              "Sprinklr",
            ],

            datasets: [
              {
                label: "No. of selected students",
                data : [16, 10, 9, 8, 6, 5, 4, 4, 3, 2, 14, 9, 9, 6, 3, 3, 3, 2, 1, 9, 7, 5, 5, 5, 3, 3, 3, 2, 2, 2, 1],
                backgroundColor: "rgba(238, 89, 152, 1)",
                borderColor: "rgba(138, 44, 191, 1)",
                borderWidth: 1,
              },
            ],
          }}
          height={400}
          options={{
            maintainAspectRatio: false,
            scales: {
              x: {
                beginAtZero: true,
                ticks: {
                  maxRotation: 90,
                  minRotation: 45,
                },
              },
              y: {
                beginAtZero: true,
              },
            },
            plugins: {
              legend: {
                position: "top",
              },
              tooltip: {
                enabled: true,
                callbacks: {
                  label: (tooltipItem) => `Selected: ${tooltipItem.raw}`,
                },
              },
            },
          }}
        />
      </div>
    </Container>
  );
};

export default Day1CompanyWise;
